<template>
  <div class="bullet-screen-container">
    <div
      v-for="item in bulletScreenStore.bulletScreenList"
      :key="item.id"
      class="bullet-screen-item"
      :style="{
        top: item.top + 'px',
        animationDuration: item.duration + 's'
      }"
      @animationend="() => bulletScreenStore.removeBulletScreen(item.id)"
    >
      {{ item.text }}
    </div>
  </div>
</template>

<script setup>
import { useBulletScreenStore } from '@/stores/customer/bulletScreenStore'
const bulletScreenStore = useBulletScreenStore()
</script>

<style scoped>
.bullet-screen-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 200px;
  overflow: hidden;
  pointer-events: none;
  z-index: 1000;
}

.bullet-screen-item {
  position: absolute;
  white-space: nowrap;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  right: 0;
  transform: translateX(0);
  animation: bulletMove linear forwards;
  will-change: transform;
  backface-visibility: hidden;
}

@keyframes bulletMove {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100vw);
  }
}
</style>